import {
  MockMap,
} from '@ama-sdk/core';
import {
  AcceptanceRepository,
  BaggageRepository,
  combineCheckInBaggagePolicies,
  combineJourneys,
  createBaggage,
  createJourney,
  createMockData,
  createMockDataWithResponse,
  RegulatoryDetailsReplyDataRepository,
} from '@dapi/sdk/spec';
import {
  addedBaggageTemplate,
  defaultBoardingPassResult,
  defaultCheckInBaggagePolicies,
  owtripSeatmap,
} from '../../mock/data';
import {
  journeyTemplateIneligiblePax,
  journeyTemplateSingleJourney,
} from '../../mock/dictionaries';
import {
  assignSeatToJourneyElements,
} from './common/seatmap';

const journeysSinglePax = combineJourneys([journeyTemplateSingleJourney]).items;
const journeysMultiPax = combineJourneys([journeyTemplateIneligiblePax]).items;
const addTravelerToJourney = combineJourneys([journeyTemplateIneligiblePax]).items[0];
/**
 * OW 1Journey
 * 1 eliglibe pax + 1 ineligible pax
 * Add ineligible pax from another booking
 */
export const ow1JourneyAddInEligiblePaxFromAnotherBooking: MockMap = {
  assignSeatToJourneyElement: assignSeatToJourneyElements(journeysSinglePax[0], owtripSeatmap).map((seat) => createMockDataWithResponse(seat, 201)),
  generateBoardingPasses: [createMockDataWithResponse(defaultBoardingPassResult, 201)],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies([defaultCheckInBaggagePolicies]).items)],
  getJourneyUnpaidItems: [createMockDataWithResponse(undefined, 404, [{
    code: '10000',
    title: 'No unpaid service',
    type: 'error',
    id: '10000'
  }])],
  getRegulatoryDetails: [createMockData(RegulatoryDetailsReplyDataRepository.DEFAULT)],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201), createMockDataWithResponse(AcceptanceRepository.ACCEPTED, 201)],
  retrieveJourneyBaggages: [createMockData([BaggageRepository.DEFAULT])],
  retrieveJourneys: [createMockDataWithResponse(journeysSinglePax, 201), createMockDataWithResponse([{
    ...journeysMultiPax[0],
    acceptance: AcceptanceRepository.ACCEPTED
  }], 201)],
  retrieveJourney: [
    createMockData(
      createJourney({
        template: {
          ...journeysSinglePax[0],
          acceptance: AcceptanceRepository.ACCEPTED
        }
      })
    )
  ],
  retrieveSeatMapsJourneyDriven: [createMockData(owtripSeatmap)],
  addTravelerToJourney: [createMockData(addTravelerToJourney)],
  addJourneyBags: [createMockData([
    createBaggage({
      template: addedBaggageTemplate,
      id: 0
    })
  ])]
};
